module.exports = __webpack_public_path__ + "img/8_71.0d62423c.png";